export default __webpack_public_path__ + "static/media/IMG_3063_1_11zon.49f4666c.jpg";